<script>
    import { Link } from "svelte-routing";

    export let user;
</script>

<style>
    .nav-bar-container {
        width: 100%;
        max-width: 500px;
    }

    .nav_link {
        color: white !important;
    }
    .nav_link:hover {
        color: white !important;
    }

    .nav_link:visited {
        color: white !important;
    }

    @media (min-width:601px) {
        .hide_mobile {
            display: none
        }
    }
    
</style>

<div class="nav-bar-container">

    <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">

    <Link to="wear-testing/program">
        <img src="/images/wear-tester-logo.png" style="height: 60px; width: 150px; margin-top: 15px; object-fit: contain" alt="nikecraft wear tester"/>
    </Link>

    <div style="cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <a href="/" class="body_text nav_link" style="margin: 0; margin-right: 10px; font-size: 15px; color: white !important;">HOME</a>
    </div>
    </div>

    <div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 30px">
    <div style="cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <Link to="wear-testing/program" class="body_text nav_link" style="margin: 0; margin-right: 10px; font-size: 15px; color: white !important;">WEAR TESTER</Link>
    </div>

    <div style="cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <Link to="wear-testing/challenges" class="body_text nav_link" style="margin: 0; margin-right: 10px; font-size: 15px; color: white !important;">CHALLENGES</Link>
    </div>

    {#if user != null}
    <div style="cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <Link to="wear-testing/submit" class="body_text nav_link" style="margin: 0; margin-right: 10px; font-size: 15px; color: white !important;">SUBMIT</Link>
    </div>
    {/if}

    {#if user == null}
    <div style="cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <Link to="wear-testing/login" class="body_text nav_link" style="margin: 0; margin-right: 10px; font-size: 15px; color: white !important;">LOG IN</Link>
    </div>
    {/if}
</div>

<img class="hide_mobile" src="/images/line.png" style="width: 100%; object-fit: contain; height: 5px;" alt=""/>

</div>
